import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { toDisplayDate } from '../shared/validation/Validate'
import type { ValidationI18n } from '../shared/validation/Validate'

/**
 * Frontend `ValidationI18n` for the shared validation rules. Renders a rule's
 * message key via i18next at call time (in the active language) and formats
 * interpolated numbers/dates with Intl. Drop-in replacement for the Lingui
 * `i18n` that used to be passed into the rule factories, e.g.
 * `employeeBankingRules(useValidationI18n())`.
 */
export function useValidationI18n(): ValidationI18n {
  const { t, i18n } = useTranslation()
  return useMemo<ValidationI18n>(
    () => ({
      _: (msg) => t(msg.key, { ...(msg.params ?? {}) }),
      date: (value, format) =>
        new Intl.DateTimeFormat(i18n.language, format).format(
          toDisplayDate(value)
        ),
      number: (value, format) =>
        new Intl.NumberFormat(i18n.language, format).format(value),
    }),
    [t, i18n.language]
  )
}
